import { useTheme } from 'react-admin';
import { Chip } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CreateIcon from '@mui/icons-material/Create';

export const GreenChip = () => <Chip icon={<CheckCircleIcon />} label="Approved" color="success" />;

export const YellowChip = () => {
  const [theme] = useTheme();
  const backgroundColor = theme === 'dark' ? '#FFFFA7' : '#ffff5b';
  return (
    <Chip
      icon={<CreateIcon />}
      label="Draft"
      color="success"
      sx={{ backgroundColor, color: 'black' }}
    />
  );
};
